<template>
  <div
    class="
      toast-notify
      p-1
      left-4
      gap-1
      bg-easy-grey
      rounded-xl
      border-2 border-easy-grey
      hover:border-yellow
      z-20
    "
    :style="{ top: `${6 + sessionStore.toastCount * 3}rem` }"
  >
    <span class="text-sm flex items-center pr-4">
      <svg
        class="w-8 h-8 mr-1 text-red-500"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      Camera turned off due to poor connection.
    </span>
    <button
      @click="bandwidthStore.openModal"
      class="
        p-1
        text-xs
        leading-5
        font-semibold
        text-vice-teal-700
        border-light-green
        rounded-md
        border-2
        hover:border-vice-teal-600
        hover:bg-vice-teal-100
      "
    >
      BANDWIDTH CONTROL
    </button>
    <button @click="closeToast">
      <CrossSimpleIcon type="link" class="text-vice-dark-grey hover:text-strong-grey" />
    </button>
  </div>
</template>

<script>
import { onMounted, onUnmounted } from 'vue';
import useSessionStore from '@/Stores/useSessionStore';
import CrossSimpleIcon from '@/Components/Icons/CrossSimpleIcon.vue';
import useBandwidthControlStore from '@/Stores/useBandwidthControlStore';

export default {
  components: { CrossSimpleIcon },
  emits: ['cameraTurnedOff', 'toastDismissed'],
  setup(props, { emit }) {
    const sessionStore = useSessionStore();
    const bandwidthStore = useBandwidthControlStore();

    const closeToast = () => emit('toastDismissed');

    onMounted(() => {
      sessionStore.toastCount += 1;
      emit('cameraTurnedOff', true);

      // Play audio notification
      const audioSource = `/audio/toasts/stethoscope_connected.mp3`;
      const audio = new Audio(audioSource);

      try {
        audio.play();
      } catch (error) {
        console.error('Error playing audio notification:', error);
      }
    });

    onUnmounted(() => {
      sessionStore.toastCount -= 1;
    });

    return { closeToast, sessionStore, bandwidthStore };
  },
};
</script>
<style scoped></style>
